import React, { memo } from 'react';
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin/colors';
import { SVG_COMPONENTS } from '@/assets/admin';
import { TAG_PRESET_COLORS } from '@/constants/residents/corkBoardConstants';

interface TagColorPickerProps {
  selectedColor: string | null;
  onSelectColor: (color: string | null) => void;
}

export const TagColorPicker: React.FC<TagColorPickerProps> = memo(({ selectedColor, onSelectColor }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>Color</Text>
      <View style={styles.grid}>
        {TAG_PRESET_COLORS.map((color) => {
          const isSelected = selectedColor === color;
          return (
            <TouchableOpacity
              key={color}
              style={[styles.swatch, { backgroundColor: color }, isSelected && styles.swatchSelected]}
              onPress={() => onSelectColor(isSelected ? null : color)}
              activeOpacity={0.7}
              accessibilityLabel={`Color ${color}`}
              accessibilityRole="radio"
              accessibilityState={{ selected: isSelected }}
            >
              {isSelected && <SVG_COMPONENTS.CHECK_CIRCLE width={16} height={16} color="#FFFFFF" />}
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
});

TagColorPicker.displayName = 'TagColorPicker';

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: '500',
    color: ADMIN_COLORS.TEXT.SECONDARY,
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
  swatch: {
    width: 36,
    height: 36,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
  },
  swatchSelected: {
    borderWidth: 2,
    borderColor: '#FFFFFF',
  },
});
